module.exports = __webpack_public_path__ + "static/media/62.ab7e9dc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/62.svg
// module id = 165
// module chunks = 0